/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('oauth.password-reset', {
      url: '/password-reset?id&token',
      template: '<password-reset></password-reset>',
      data: { pageTitle: 'Forgot Password? No Worries | Recovery your Account' },
    });
}



// WEBPACK FOOTER //
// ./client/app/oauth/password-reset/password-reset.routes.js